module.exports = __webpack_public_path__ + "img/sec18mob.dc1f3900.png";